import { HttpErrorResponse } from '@angular/common/http';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { IAccountingBasisExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { Subject } from 'rxjs';

export interface IAccountingBasisFormData {
    accountingBasis: IAccountingBasisExtendedDTO | undefined;
    errorMessage: Subject<HttpErrorResponse>;
    countries: INameId[];
}
